<div [formGroup]="theForm" class="fieldWrapper">
    <label class="label" fxFlex="1 1 60%">
        <span matTooltip="{{ metaData?.description }}">{{ metaData?.friendlyName }}</span>
    </label>
    <span class="toggle" fxFlex="1 1 40%">
        <mat-slide-toggle
            #formControl
            color="primary"
            [formControlName]="metaData?.inputName"
            [aria-label]=""
            matTooltip="{{ metaData?.description }}"
        ></mat-slide-toggle>
    </span>
    <div *ngIf="formControl.disabled && !isLoading && enableRetry">
        <mat-button-toggle (click)="getValueEmitter.emit()">Retry</mat-button-toggle>
    </div>
    <clare-spinner *ngIf="isLoading" text="Loading Value" position="absolute" overlay="true"></clare-spinner>
</div>
